<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="position-fixed bottom-0  w-100 p-xs-3 toast-div">
    <div *ngFor="let toast of toastService.toasts; let i = index" class="toastCss d-flex justify-content-between p-0">
      <div class="vector"><img class="mt-3 ms-3" src="/content/images/icons/vector.png" width="20" height="20" alt=""/>
      </div>
      <div class="mt-3 ms-1">{{ toast }}</div>
      <div class="mt-3"><button (click)="removeToast(i)" class="toast-btn">{{'main.charX' | translate}}</button></div>
    </div>
  </div>
